import api from './api'

export interface ExchangeRate {
  id: number
  fromCurrency: string
  toCurrency: string
  rate: number
  effectiveDate: string
  isActive: boolean
}

export interface ExchangeRateHistory {
  date: string
  rate: number
  isActive: boolean
}

export const exchangeRateService = {
  async getCurrentRate(): Promise<{ exchangeRate: ExchangeRate | null }> {
    const response = await api.get('/exchange-rates/current')
    return response.data.data
  },

  async getRates(params?: { page?: number; limit?: number }) {
    const response = await api.get('/exchange-rates', { params })
    return response.data.data
  },

  async createExchangeRate(data: {
    fromCurrency: string
    toCurrency: string
    rate: number
    effectiveDate: string
  }) {
    const response = await api.post('/exchange-rates', data)
    return response.data
  },

  async updateExchangeRate(id: number, data: { rate: number; isActive?: boolean }) {
    const response = await api.put(`/exchange-rates/${id}`, data)
    return response.data
  },

  async getHistory(days: number = 30) {
    const response = await api.get('/exchange-rates/history', { params: { days } })
    return response.data.data
  }
}